module.exports = __webpack_public_path__ + "static/media/regen.a5ad3712.png";